import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../../services/apiService';
import { mapState } from 'vuex';
import intersection from 'lodash/intersection';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import uniq from 'lodash/uniq';
export default {
  name: 'CoreDtwinRuleCopy',
  props: {
    tenantId: {
      type: Number,
      required: true
    },
    dtwinId: {
      type: Number,
      required: true
    },
    states: {
      type: Array,
      required: true
    },
    rule: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    var _this = this;

    return {
      formIsValid: false,
      selectedTargetTwins: [],
      requiredRule: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }],
      targetTwinsStateMetrics: {},
      targetTwinsAggregateStates: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    aggregateStatesOfSourceRule: function aggregateStatesOfSourceRule() {
      var _this2 = this;

      return (get(this.rule, 'properties.triggeredAggregates') || []).map(function (triggered) {
        return _this2.states.find(function (s) {
          return s.id === triggered.stateId;
        });
      }).filter(function (s) {
        return s;
      });
    },
    statesUsedBySourceRule: function statesUsedBySourceRule() {
      var _this3 = this;

      // return only those states that are used by the rule as metrics or referenced as triggered aggregate-state
      return this.states.filter(function (state) {
        return intersection([state.id], _this3.rule.stateIds).length > 0 || intersection([state.id], _this3.aggregateStatesOfSourceRule.map(function (agg) {
          return agg.id;
        })).length > 0;
      });
    }
  }),
  methods: {
    verifyTwinCanBeUsedAsCopyTarget: function verifyTwinCanBeUsedAsCopyTarget(_twin, _parents, statesOfTwinToVerify) {
      if (this.aggregateStatesOfSourceRule.length > 0) {
        var uniqueBindingTypes = uniq(this.aggregateStatesOfSourceRule.map(function (las) {
          return las.properties.binding.type;
        }));
        var hasMatchingAggregateStates = this.aggregateStatesOfSourceRule.filter(function (las) {
          return statesOfTwinToVerify.findIndex(function (s) {
            return s.properties.binding.type === las.properties.binding.type;
          }) >= 0;
        }).length >= uniqueBindingTypes.length;

        if (!hasMatchingAggregateStates) {
          return false;
        }
      }

      var uniqueValueTypesOfSourceRule = uniq(this.statesUsedBySourceRule.map(function (state) {
        return state.properties.valueType;
      }));
      var statesWithSameValueTypeBetweenTargetAndOrigin = this.statesUsedBySourceRule.filter(function (sourceRuleState) {
        var targetTwinStates = Array.isArray(statesOfTwinToVerify) ? statesOfTwinToVerify : [statesOfTwinToVerify];
        return targetTwinStates.some(function (targetTwinState) {
          return targetTwinState.properties.valueType === sourceRuleState.properties.valueType;
        });
      });
      var amountOfStatesWithSameValueTypeBetweenTargetAndOrigin = statesWithSameValueTypeBetweenTargetAndOrigin.length;
      var result = amountOfStatesWithSameValueTypeBetweenTargetAndOrigin >= uniqueValueTypesOfSourceRule.length;
      return result;
    },
    validStatesForMetric: function validStatesForMetric(metricStateId, twinStates) {
      var metricState = this.states.find(function (s) {
        return s.id === metricStateId;
      });
      return twinStates.filter(function (s) {
        return metricState.properties.valueType === s.properties.valueType;
      });
    },
    validStatesForAggregation: function validStatesForAggregation(aggState, twinStates) {
      return twinStates.filter(function (s) {
        return aggState.properties.binding.type === s.properties.binding.type;
      });
    },
    onTargetTwinSelected: function onTargetTwinSelected(e) {
      this.selectedTargetTwins.push(e);
      this.targetTwinsStateMetrics[e.id] = {};
      this.targetTwinsAggregateStates[e.id] = {};
    },
    onTargetTwinDeselected: function onTargetTwinDeselected(e) {
      this.selectedTargetTwins = this.selectedTargetTwins.filter(function (t) {
        return t.id !== e.id;
      });
      delete this.targetTwinsStateMetrics[e.id];
      delete this.targetTwinsAggregateStates[e.id];
    },
    createRuleCopies: function createRuleCopies() {
      var _this4 = this;

      Promise.all(this.selectedTargetTwins.map(function (twin) {
        var ruleToCreateInTargetTwin = cloneDeep(_this4.rule);
        ruleToCreateInTargetTwin.dtwinId = twin.id;
        ruleToCreateInTargetTwin.properties.stateMetrics.forEach(function (metric) {
          metric.stateId = _this4.targetTwinsStateMetrics[twin.id][metric.key];
        });
        ruleToCreateInTargetTwin.properties.triggeredAggregates.forEach(function (aggregation) {
          aggregation.stateId = _this4.targetTwinsAggregateStates[twin.id][aggregation.stateId];
        });
        return ApiService.digitalTwinCreateRule(_this4, ruleToCreateInTargetTwin);
      })).then(function () {
        _this4.$snack(_this4.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.copy.copySuccess'), 'success');

        _this4.$emit('created');
      }).catch(function (error) {
        console.error(error);
      });
    }
  }
};